import React from 'react';
import * as Yup from 'yup';
import { Formik, Form } from 'formik';
import { Input } from '@appkit4/react-components/field';
import { Button } from '@appkit4/react-components/button';
import useLocale from '../../../../../locale/useLocale';

interface CreateContactPersonFormProps {
    submitFunc: (newContactPerson: FormValues) => void;
}

export interface FormValues {
    forenames: string;
    surname: string;
    email: string;
}

const CreateContactPersonForm = (props: CreateContactPersonFormProps) => {
    const { l } = useLocale();

    const NewContactPersonSchema = Yup.object({
        forenames: Yup.string()
            .trim()
            .max(100, l('_pleaseEnterFewerCharacters'))
            .required(l('_pleaseEnterForename(s)')),
        surname: Yup.string()
            .trim()
            .max(100, l('_pleaseEnterFewerCharacters'))
            .required(l('_pleaseEnterASurname')),
        email: Yup.string()
            .trim()
            .max(250, l('_pleaseEnterFewerCharacters'))
            .email(l('_pleaseEnterAValidEmailAddress'))
            .required(l('_pleaseEnterAnEmailAddress')),
    });

    return (
        <Formik
            initialValues={{
                forenames: '',
                surname: '',
                email: '',
            }}
            validationSchema={NewContactPersonSchema}
            onSubmit={(values) => props.submitFunc(values)}
        >
            {({
                errors,
                touched,
                setFieldTouched,
                setFieldValue,
                validateField,
            }) => (
                <Form>
                    <div className="row focus-margin">
                        <div className="col">
                            <Input
                                type="text"
                                data-cy="forename"
                                title={l('_forename(s)')}
                                placeholder={l('_forename(s)')}
                                required
                                onChange={(value: string) => {
                                    setFieldTouched('forenames');
                                    validateField('forenames');
                                    setFieldValue('forenames', value);
                                }}
                            />
                            {touched.forenames && errors.forenames && (
                                <div className="error-text">
                                    {errors.forenames}
                                </div>
                            )}
                        </div>

                        <div className="col">
                            <Input
                                type="text"
                                data-cy="surname"
                                title={l('_surname')}
                                placeholder={l('_surname')}
                                required
                                onChange={(value: string) => {
                                    setFieldTouched('surname');
                                    validateField('surname');
                                    setFieldValue('surname', value);
                                }}
                            />
                            {touched.surname && errors.surname && (
                                <div className="error-text">
                                    {errors.surname}
                                </div>
                            )}
                        </div>
                    </div>

                    <Input
                        type="text"
                        data-cy="email"
                        title={l('_email')}
                        placeholder={l('_email')}
                        required
                        onChange={(value: string) => {
                            setFieldTouched('email');
                            validateField('email');
                            setFieldValue('email', value);
                        }}
                        className="mt-3"
                    />
                    {touched.email && errors.email && (
                        <div className="error-text">{errors.email}</div>
                    )}

                    <Button className="ms-auto mt-5" type="submit">
                        {l('_createNewContact')}
                    </Button>
                </Form>
            )}
        </Formik>
    );
};

export default CreateContactPersonForm;
